import { ClipLoader } from 'react-spinners'

export default function Spinner() {
  const cssOverride = {
    animation: 'spinner-rotate 1s 0s infinite linear',
    borderWidth: '8px',
    borderColor:
      'var(--color-primary, #222222) var(--color-primary, #222222) var(--color-primary, #222222) #FFFFFF',
  }

  return (
    <>
      <style>
        {`
        @keyframes spinner-rotate {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        `}
      </style>
      <ClipLoader size={52} cssOverride={cssOverride} />
    </>
  )
}
